import type { CustomIconProps } from '../CustomIcon';

export const UserAddIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M20 8v6M23 11h-6M8.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z'
        fill={solid ? color : 'transparent'}
        stroke={solid ? secondaryColor : color}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
